import React from 'react';
import './LIRCareers.css';
import { Link } from 'react-router-dom';

const LIRCareers = () => {
  return (
    <>
      <h1 className='Mainhead11'>Join Us to <span className='Mainhead12'>Shape Your Career</span></h1>
      <div className="lirc-wrapper1">
        <div className="lirc-image1">
          <img
            src="https://t4.ftcdn.net/jpg/00/84/56/81/360_F_84568194_kQ2l6haADAClpH0ZLE5W3CY1k52CxWtY.jpg"
            alt="Career Opportunities"
          />
        </div>
        <div className="lirc-content1">
          <p>
            Explore opportunities across <strong>IT</strong>, <strong>Non-IT</strong>, and <strong>specialized services</strong> with Adithya Infinity.  
            From technology-driven roles to core business functions, we provide the right platform to grow and succeed. 
          </p>
          <p>
            Be part of a team that values innovation, collaboration, and ambition—where every role makes an impact.  
          </p>
          <Link to="/joblist">
            <button className="cta-button1">Explore Open Positions →</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default LIRCareers;
